<template>
  <FlexColumn class="recommend-job my-12" :space="5" width="960px">
    <p class="title font-weight-bold">おすすめ求人</p>
    <FlexRow class="justify-space-between" :space="0">
      <FlexColumn
          v-for="(recommendedJob,i) in recommendJobs"
          :key="i"
          class="recommend-job_item"
          @click.native="$router.push(`/jobs/${recommendedJob.id}`)"
      >
        <v-img
            v-if="recommendedJob.image1"
            :src="recommendedJob.image1.url"
            width="300px" height="145px"
        />
        <v-img
            v-else
            src="@/assets/no_image_gray.png"
            width="300px" height="145px"
        />
        <div class="recommend-job_chip">
          <div class="jobTag side" v-if="recommendedJob.side">副業</div>
          <div class="jobTag" v-else>正社員</div>
        </div>

        <div class="recommend-job_title">{{ recommendedJob.name }}</div>
        <div class="recommend-job_detail">
          <span v-if="salary(recommendedJob)">{{ salary(recommendedJob) }}</span>
          <span v-if="prefecture(recommendedJob)">{{ prefecture(recommendedJob) }}</span>
          <span v-if="remoteStatus(recommendedJob)">{{ remoteStatus(recommendedJob) }}</span>
        </div>
        <div>{{ recommendedJob.company.name }}</div>
      </FlexColumn>
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexColumn from '../atoms/FlexColumn'
import FlexRow from '../atoms/FlexRow'
import ComponentMixin from '../ComponentMixin'
import ApiMixin from '../../ApiMixin'

export default {
  name: 'JobDetailRecommendPanel',
  components: { FlexRow, FlexColumn },
  mixins: [ComponentMixin, ApiMixin],
  props: {
    recommendJobs: {
      type: Object,
      required: true
    }
  },
  computed: {
    salary() {
      return (job) => {
        if (job.side) {
          const { hourlyWageMin, hourlyWageMax } = job.side
          if (hourlyWageMin && hourlyWageMax) return `${hourlyWageMin}~${hourlyWageMax}円/時間`
          if (!hourlyWageMin && hourlyWageMax) return `~${hourlyWageMax}円/時間`
          if (hourlyWageMin && !hourlyWageMax) return `${hourlyWageMin}円/時間~`
          if (!hourlyWageMin && !hourlyWageMax) return ''
        } else {
          const { lowerSalary, upperSalary } = job
          if (lowerSalary && upperSalary) return `${lowerSalary}~${upperSalary}万円`
          if (!lowerSalary && upperSalary) return `~${upperSalary}万円`
          if (lowerSalary && !upperSalary) return `${lowerSalary}万円~`
          if (!lowerSalary && !upperSalary) return ''
        }
      }
    },
    prefecture() {
      return (job) => {
        if (!job.prefecture) return ''
        return `${this.constsToText(job.prefecture, this.consts.preferredLocation)}`
      }
    },
    remoteStatus() {
      return (job) => {
        if (job.remoteStatus === 1) return 'フルリモート'
        if (job.remoteStatus === 2) return '一部リモート'
        if (job.remoteStatus === 3) return 'リモートなし'
        return ''
      }
    },
  }
}
</script>

<style lang="sass" scoped>
.recommend-job
  &_item
    flex-basis: 300px
    position: relative
    cursor: pointer
  &_title
    font-weight: bold
  &_detail > *:not(:last-child)::after
    content: '|'
    margin: 0 6px
  &_chip
    position: absolute
    top: 10px
    left: 10px

  .jobTag
    color: white
    font-weight: bold
    line-height: 20px
    text-align: center
    background-color: #CBC74E
    width: 60px
    height: 20px

  .jobTag.side
    background-color: #FF5757
</style>